(function ($) {
  'use strict';

  function setHeaderNavigationLogoHeight() {
    var logoHeight = parseInt($('.site-logo img').height(), 10);
    logoHeight = logoHeight > 22 ? logoHeight : 104;
    $('.header__logo-navigation').height(logoHeight + 'px');
    $('.header__menu').css('top', logoHeight + 'px');
  }

  $(document).ready(function () {
    // Set height of logo navigation wrapper to avoid whitespace.
    setHeaderNavigationLogoHeight();
    $(window).resize(setHeaderNavigationLogoHeight);

    // By clicking on the burger menu logo toggle the menu.
    $('.header__navigation-logo').click(function () {
      $('.header__menu').stop(true, false, true).slideToggle(300, function () {
        if ($(this).hasClass('header__menu--visible')) {
          $(this).removeClass('header__menu--visible');
        }
        else {
          $(this).addClass('header__menu--visible');
        }
      });
      return false;
    });

    // By clicking outside the header menu close the menu.
    $(document).click(function (event) {
      if (!$(event.target).closest('.header__navigation-menu').length) {
        if ($('.header__menu').is(':visible')) {
          $('.header__menu').slideUp(300);
        }
      }
    });
  });
})(jQuery);
